"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DeliveryActions = void 0;
var DeliveryActions;
exports.DeliveryActions = DeliveryActions;

(function (DeliveryActions) {
  DeliveryActions["Tip"] = "DeliveryTip";
  DeliveryActions["Estimate"] = "DeliveryNewEstimate";
  DeliveryActions["Promo"] = "DeliveryPromo";
})(DeliveryActions || (exports.DeliveryActions = DeliveryActions = {}));